import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function WhoIsItFor() {
  return <section className="w-full bg-[#F5EDE3] px-4 py-16 md:py-24" data-id="element-198">
      <div className="max-w-4xl mx-auto" data-id="element-199">
        <h2 className="text-3xl md:text-4xl font-bold text-[#1B2A4A] mb-12 font-serif text-center" data-id="element-200">
          Para quién es (y para quién no)
        </h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-201">
          {/* For You */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-[#2D6A4F]" data-id="element-202">
            <h3 className="text-2xl font-bold text-[#1B2A4A] mb-6 font-serif flex items-center" data-id="element-203">
              <span className="bg-[#2D6A4F]/10 p-2 rounded-full mr-3" data-id="element-204">
                <Check className="h-6 w-6 text-[#2D6A4F]" data-id="element-205" />
              </span>
              Es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-206">
              <li className="flex items-start text-[#4A5568]" data-id="element-207">
                <Check className="h-5 w-5 text-[#2D6A4F] mt-0.5 mr-3 flex-shrink-0" data-id="element-208" />
                Ya te cansaste de negociar
              </li>
              <li className="flex items-start text-[#4A5568]" data-id="element-209">
                <Check className="h-5 w-5 text-[#2D6A4F] mt-0.5 mr-3 flex-shrink-0" data-id="element-210" />
                Te duele ceder, pero estás agotado/a
              </li>
              <li className="flex items-start text-[#4A5568]" data-id="element-211">
                <Check className="h-5 w-5 text-[#2D6A4F] mt-0.5 mr-3 flex-shrink-0" data-id="element-212" />
                Quieres límites sin convertirte en policía
              </li>
              <li className="flex items-start text-[#4A5568]" data-id="element-213">
                <Check className="h-5 w-5 text-[#2D6A4F] mt-0.5 mr-3 flex-shrink-0" data-id="element-214" />
                Necesitas un plan que funcione en días “normales”, no en días
                perfectos
              </li>
            </ul>
          </motion.div>

          {/* Not For You */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-[#C53030]" data-id="element-215">
            <h3 className="text-2xl font-bold text-[#1B2A4A] mb-6 font-serif flex items-center" data-id="element-216">
              <span className="bg-[#C53030]/10 p-2 rounded-full mr-3" data-id="element-217">
                <X className="h-6 w-6 text-[#C53030]" data-id="element-218" />
              </span>
              No es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-219">
              <li className="flex items-start text-[#4A5568]" data-id="element-220">
                <X className="h-5 w-5 text-[#C53030] mt-0.5 mr-3 flex-shrink-0" data-id="element-221" />
                Quieres “0 pantallas desde mañana” sin transición
              </li>
              <li className="flex items-start text-[#4A5568]" data-id="element-222">
                <X className="h-5 w-5 text-[#C53030] mt-0.5 mr-3 flex-shrink-0" data-id="element-223" />
                Buscas un milagro sin sostener una regla 7 días
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}